import YhSelect from "../../../../ui/YhSelect";
import YhButton from "../../../../ui/YhButton";
import { CreateScheduling } from "../../Service/Service";
import history from "../../../../utils/history";
import urls from "../../../../global/constants/UrlConstants";

interface CustomProps {
  nextStep?: () => void | undefined;
  backStep?: () => void | undefined;
  userId: String;
  setUserId?: Function;
  fromSettingOrLogout?: any;
  state?: any;
  setStateData?: any;
}

const CANCELLATION_OPTIONS = [
  { label: "Allowed", value: "allow" },
  { label: "Not Allowed", value: "not_allow" },
];

const RESCHEDULING_OPTIONS = [
  { label: "Not Allowed", value: "not_allowed" },
  { label: "Allowed anytime", value: "allow_anytime" },
  { label: "Allowed up to 24 hours before", value: "allow_24_hours" },
];

const Scheduling = (props: CustomProps) => {
  const submitForm = async () => {
    await CreateScheduling({
      meetingId: props.state?.meetingId,
      rescheduling: props.state?.rescheduling,
      cancellation: props.state?.cancellation,
    });
    history.push(urls.meetingListViewPath);
  };

  const goBack = () => {
    props.backStep?.();
  };

  return (
    <div className="flex h-full min-h-0 w-full flex-col overflow-hidden rounded-2xl border border-[#EEF0F5] bg-white shadow-[0_4px_20px_rgba(15,23,42,0.04)]">
      <div className="min-h-0 flex-1 overflow-auto p-5 sm:p-6">
        <div className="mb-5 border-b border-[#F3F4F6] pb-4">
          <h1 className="text-xl font-bold tracking-tight text-[#111827]">
            Scheduling
          </h1>
          <p className="mt-1 text-sm text-[#6B7280]">
            Provide essential information about the project
          </p>
        </div>

        <div className="grid max-w-3xl grid-cols-1 gap-5 md:grid-cols-2">
          <YhSelect
            label="Rescheduling"
            placeholder="Select"
            options={RESCHEDULING_OPTIONS}
            value={props.state?.rescheduling || ""}
            onChange={(e) =>
              props.setStateData({ rescheduling: e.target.value })
            }
          />
          <YhSelect
            label="Cancellation"
            placeholder="Select"
            options={CANCELLATION_OPTIONS}
            value={props.state?.cancellation || ""}
            onChange={(e) =>
              props.setStateData({ cancellation: e.target.value })
            }
          />
        </div>
      </div>

      <div className="sticky bottom-0 z-10 flex shrink-0 flex-wrap items-center justify-between gap-3 border-t border-[#EEF0F5] bg-white px-5 py-4 sm:px-6">
        <YhButton
          variant="secondary"
          fullWidth={false}
          onClick={goBack}
          className="!w-auto"
        >
          Go Back
        </YhButton>
        <YhButton
          variant="primary"
          fullWidth={false}
          onClick={submitForm}
          className="!w-auto"
        >
          Save →
        </YhButton>
      </div>
    </div>
  );
};

export default Scheduling;
